import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import PaymentGatewayServices from "services/PaymentgatewayServices";
import { notifyError, notifySuccess } from "utils/toast";

const usePaymentGatewaySubmit = (gatewayId) => {
  const { isDrawerOpen, closeDrawer,setIsUpdate } = useContext(SidebarContext);

  const [dataInput, setDataInput] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm();

  const getGatewayData = async () => {
    if (!gatewayId) return;

    try {
      const res = await PaymentGatewayServices.getGatewayById(gatewayId);

      if (res?.status && res?.data) {
        const { payment_types, charges } = res.data;

        const formattedData = payment_types.map((type, index) => {
          const charge = charges[type] ?? 0;
          setValue(`charge_${index}`, charge);

          return {
            payment_type: type,
            charge,
          };
        });

        setDataInput(formattedData);
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      for (const item of dataInput) {
        await PaymentGatewayServices.updateGatewayCharge(gatewayId, {
          payment_type: item.payment_type,
          charge: Number(item.charge),
        });
      }

      notifySuccess("Payment gateway updated successfully");
      setIsUpdate(true);
      closeDrawer();
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setDataInput([]);
      clearErrors();
      
      return;
    }

    getGatewayData();
  }, [gatewayId, isDrawerOpen]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,
    dataInput,
    setDataInput,
  };
};

export default usePaymentGatewaySubmit;
